import { useState } from "react";

import { t } from "i18next";
import { IButton, ILoginAndRegister, IOptions, IText } from "../../../interfaces/event/loginAndRegister"
import { breakpointSize } from "../../../theme/mediaQuerie";
import { AlignActions } from "../../shared-v2/AlignActions";
import { Label } from "../../shared-v2/Label";
import { Subtitle } from "../../shared-v2/Subtitle";
import { TextActions } from "../../shared-v2/TextActions";
import { TextArea } from "../../shared-v2/TextArea";
import { IFile, UploadImage } from "../../shared-v2/UploadImage";
import Input from "../../shared/input/Input";
import InputColorPicker from "../../shared/inputColorPicker/InputColorPicker";
import PageTitle from "../../shared/pageTitle/PageTitle";
import { Column, InputGroup, Row, RowGrid } from "./style";

interface IProps {
  loginAndRegister: ILoginAndRegister;
  setLoginAndRegister: React.Dispatch<React.SetStateAction<ILoginAndRegister>>;
}

const isMobile = window.innerWidth <= breakpointSize.Sm;

export const LoginAndRegister = ({loginAndRegister, setLoginAndRegister}: IProps) => {
  const [file, setFile] = useState<IFile | null>(null);

  const updateText = (attr: keyof IText, value: string) => {
    setLoginAndRegister(prev => ({...prev, options: {...prev.options, text: {
      ...prev.options.text, [attr]: value
    }}}));
  }

  const updateButton = (attr: keyof IButton, value: string) => {
    setLoginAndRegister(prev => ({...prev, options: {...prev.options, button: {
      ...prev.options.button, [attr]: value
    }}}));
  }

  const updateOptions = (attr: keyof IOptions, value: string) => {
    setLoginAndRegister(prev => ({...prev, options: {...prev.options, [attr]: value}}));
  }
  
  return(
    <>
      { !isMobile && <PageTitle style={{margin: 0}}>{t("dashboard.event.loginAndRegister.title")}</PageTitle> }
    
      <RowGrid>
        <Column>
          <Row>
            <Label>{t("title")}</Label>
            <TextActions 
              menuDisplayMode={!isMobile}
              setTextAlign={(value) => updateText("align", value)}
              textAlign={loginAndRegister.options.text.align} 
            />
            {!isMobile && (
              <AlignActions 
                menuDisplayMode={!isMobile}
                alignX={loginAndRegister.options.text.positionX} 
                setAlignX={(value) => updateText("positionX", value)} 
                alignY={loginAndRegister.options.text.positionY} 
                setAlignY={(value) => updateText("positionY", value)} 
              />
            )}
          </Row>
          <TextArea
            positionX={loginAndRegister.options.text.positionX}  
            positionY={loginAndRegister.options.text.positionY}
            maxLength={50} 
            textAlign={loginAndRegister.options.text.align}
            value={loginAndRegister.options.text.title} 
            onChange={(e) => updateText("title", e.target.value)}
          />
        </Column>
        <Column>
          <Label>{t("description")}</Label>
          <TextArea 
            positionX={loginAndRegister.options.text.positionX}  
            positionY={loginAndRegister.options.text.positionY}
            maxLength={50} 
            textAlign={loginAndRegister.options.text.align} 
            value={loginAndRegister.options.text.description ?? ""} 
            onChange={(e) => updateText("description", e.target.value)} 
          />
          {isMobile && (
            <AlignActions
              menuDisplayMode={!isMobile}
              alignX={loginAndRegister.options.text.positionX} 
              setAlignX={(value) => updateText("positionX", value)} 
              alignY={loginAndRegister.options.text.positionY} 
              setAlignY={(value) => updateText("positionY", value)} 
            />
          )}
        </Column>
      </RowGrid>

      <Subtitle>{t("button")}</Subtitle>

      <RowGrid>
        <InputGroup>
          {!isMobile && <Label>{t("title")}</Label>}
          <Input
            placeholder={t("dashboard.event.loginAndRegister.button.placeholder")!}
            value={loginAndRegister.options.button.title}  
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => updateButton("title", e.target.value)}
          />
        </InputGroup>
        <InputGroup>
         {!isMobile && <Label>{t("textColor")}</Label>}
          <InputColorPicker
            color={loginAndRegister.options.button.color ?? "#000"}  
            handleChangeColor={(e) => updateButton("color", e.hex)}
          />
        </InputGroup>
        <InputGroup>
          {!isMobile && <Label>{t("buttonColor")}</Label>}
          <InputColorPicker 
            color={loginAndRegister.options.button.background ?? "#fff"}  
            handleChangeColor={(e) => updateButton("background", e.hex)}
          />
        </InputGroup>
      </RowGrid>

      <RowGrid>
        <UploadImage
          file={file} 
          setFile={(file) => {updateOptions("image", file?.url ?? ""); setFile(file);}} 
          id="loginAndRegister-upload-image" 
          maxImageSize={1024 * 1024 * 10} 
          title={t("image")} 
        />
        {!isMobile && <div/>}
      </RowGrid>
    </>
  );
}